import { observer } from 'mobx-react-lite';
import { usePopupStore } from "..";
import { useConditionallyClosable } from "../hooks/useClosable";
import PopupType from "../interfaces/PopupType";
import { ClosableOrder } from "../store/ClosableStore";
import DealPopup from "./deals/DealPopup";
import LeadPopup from "./leads/LeadPopup";
import LeaseCompPopup from "./leaseComps/LeaseCompPopup";
import LocationPopup from "./locations/LocationPopup";
import PropertyPopup from "./property/PropertyPopup";
import SaleCompPopup from "./saleComps/SaleCompPopup";
import TenantInMarketPopup from "./tenantsInMarket/TenantInMarketPopup";

function PopupController() {
    const popupStore = usePopupStore();
    useConditionallyClosable(ClosableOrder.Medium, () => popupStore.close(), !!popupStore.type);

    if (!popupStore.type)
        return null;

    switch (popupStore.type) {
        case PopupType.Deal: return <DealPopup id={popupStore.id!} />;
        case PopupType.Lead: return <LeadPopup id={popupStore.id!} />;
        case PopupType.LeaseComp: return <LeaseCompPopup id={popupStore.id!} />;
        case PopupType.SaleComp: return <SaleCompPopup id={popupStore.id!} />
        case PopupType.TenantInMarket: return <TenantInMarketPopup id={popupStore.id!} />;
        case PopupType.Property: return <PropertyPopup longitude={popupStore.longitude!} latitude={popupStore.latitude!} />
        case PopupType.Location: return <LocationPopup id={popupStore.id!} />
    }
}

export default observer(PopupController);
